import React, { useState, useImperativeHandle , useEffect , useRef } from 'react';
import './../../styles/Inputs.css';

function Slider({ label, defaultValue, gridWidth, icon, onChange, visible, minValue, maxValue, step , units } , ref ) {
    const startValue = defaultValue ?? minValue;
    const [ value, setValue ] = useState( startValue );
    const debounceRef = useRef( null );
    const debounceMs = 150;
    
    useImperativeHandle(ref, () => ({
        getValue: () => value,
        setValue: ( newVal ) => setValue( newVal ),
    }));

    const handleChange = (e) => {
        const newValue = parseFloat(e.target.value);
        setValue(newValue);

        // Debounce the onChange callback
        if (debounceRef.current) {
        clearTimeout(debounceRef.current);
        }
        debounceRef.current = setTimeout(() => {
        if (typeof onChange === 'function') {
            onChange(newValue);
        }
        }, debounceMs);
    };

    const containerClass = [
        'textfield',
        gridWidth === 'HALF' ? 'half' : 'full',
        visible === false ? 'hidden' : ''
    ].join(' ').trim();

    useEffect(() => {
        return () => clearTimeout( debounceRef.current ); 
    }, []);

    return (
        <div className={containerClass}>
            {label != null && (
                <label className="textfield-label">
                    {icon != null && 
                        <span className="textfield-icon">
                            <div dangerouslySetInnerHTML={ { __html: icon } }></div>
                        </span>}
                    {label}
                </label>
            )}

            <div className="slider-row">
                <input
                    type="range"
                    min={minValue}
                    max={maxValue}
                    step={step}
                    className="slider-input"
                    value={value}
                    onChange={handleChange}
                />

                <div className="slider-value">
                    <input
                        type="number"
                        value={value}
                        min={minValue}
                        max={maxValue}
                        step={step}
                        onChange={(e) => {
                        const val = e.target.value === '' ? '' : Number(e.target.value);
                        // Optional: clamp val between min/max if needed here
                        setValue(val);
                        if (typeof onChange === 'function') {
                            onChange(val);
                        }
                        }}
                        className="number-input-custom"
                    />
                    <span>{units}</span>
                </div>
            </div>
        </div>
    );
}

export default React.forwardRef(Slider);